import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TypewriterText from '../../components/TypewriterText';
import OnboardingLayout from '../../components/onboarding/OnboardingLayout';

import { useUserPreferences } from '../../contexts/UserPreferencesContext';

const OnboardingStep1 = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { preferences, updatePreferences } = useUserPreferences();
  const progress = (1 / 14) * 100;

  return (
    <OnboardingLayout progress={progress}>
      <div className="w-full max-w-md">
        <div className="bg-white border-4 border-[#077f5d] p-8" style={{ boxShadow: '6px 6px 0 #077f5d' }}>

          <div className="text-center mb-8">
            <h1
              className="text-2xl text-center text-[#077f5d] mb-4 uppercase"
              style={{ fontFamily: "'Press Start 2P'", lineHeight: '1.3' }}
            >
              {t('onboarding.step1.title')}
            </h1>
            <div className="space-y-3 mb-4">
              <TypewriterText
                texts={[
                  t('onboarding.step1.subtitle_1'),
                  t('onboarding.step1.subtitle_2')
                ]}
                speed={35}
                delayBetween={500}
                showCursor={true}
                className="text-[#1a1a1a] font-mono text-center"
                onFinish={() => console.log('Typing done')}
                startOnView={true}
              />
            </div>
          </div>

          <div className="mb-8">
            <label
              className="block text-[#077f5d] mb-2 text-sm uppercase font-bold"
              style={{ fontFamily: "'Press Start 2P', monospace", fontSize: '10px' }}
            >
              {t('onboarding.step1.language_label')}
            </label>
            <div
              className="relative bg-white border-2 border-[#077f5d]"
              style={{ boxShadow: '4px 4px 0 #077f5d' }}
            >
              <select
                className="w-full p-3 appearance-none bg-transparent text-[#1a1a1a] font-mono focus:outline-none cursor-pointer"
                defaultValue={preferences.language}
                onChange={(e) => {
                  const newLang = e.target.value;
                  updatePreferences(preferences.currency, preferences.thousandSeparator, newLang);
                  import('../../i18n').then(i18n => i18n.default.changeLanguage(newLang));
                }}
              >
                <option value="id">Bahasa Indonesia</option>
                <option value="en">English</option>
              </select>
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                <div className="w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-[#077f5d]" />
              </div>
            </div>
          </div>

          <button
            type="submit"
            onClick={() => navigate('/onboarding/step-2')}
            className="w-full bg-[#3cbe8c] text-white px-8 py-4 border-2 border-[#077f5d] font-bold uppercase"
            style={{
              fontFamily: "'Press Start 2P', monospace",
              fontSize: '12px',
              boxShadow: '6px 6px 0 #077f5d'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '4px 4px 0 #077f5d';
              e.currentTarget.style.transform = 'translate(-2px, -2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '6px 6px 0 #077f5d';
              e.currentTarget.style.transform = 'translate(0, 0)';
            }}
          >
            {t('onboarding.step1.cta')}
          </button>
        </div>
      </div>
    </OnboardingLayout>
  );
};

export default OnboardingStep1;
